import type { Currency, InvoiceType } from '@altyor-kronos/shared-types';

export interface InvoiceFormValues {
  invoiceNumber: string;
  invoiceDate: string;
  invoiceAmount: string;
  paymentDate: string;
  type: InvoiceType | '';
  currency: Currency | '';
}

export type FormErrors<T> = Partial<Record<keyof T, string>>;

export function validateInvoiceForm(v: InvoiceFormValues): FormErrors<InvoiceFormValues> {
  const errors: FormErrors<InvoiceFormValues> = {};
  if (!v.invoiceNumber || v.invoiceNumber.trim() === '') {
    errors.invoiceNumber = 'Number is required';
  }
  if (!v.invoiceDate || !/^\d{4}-\d{2}-\d{2}$/.test(v.invoiceDate)) {
    errors.invoiceDate = 'Date is required';
  }
  const amount = Number(v.invoiceAmount);
  if (v.invoiceAmount === '' || !Number.isFinite(amount) || amount <= 0) {
    errors.invoiceAmount = 'Amount must be greater than 0';
  }
  if (v.paymentDate !== '' && !/^\d{4}-\d{2}-\d{2}$/.test(v.paymentDate)) {
    errors.paymentDate = 'Invalid payment date';
  }
  if (!v.type) errors.type = 'Type is required';
  if (!v.currency) errors.currency = 'Currency is required';
  return errors;
}
